import { Deserializable } from "../shared/models/deserializable.model";

import { Contact } from "../models/contact";
import { Business } from "../models/business";
import { Property } from "../models/property";
import { Invoice } from "../models/invoice";
import { Quote } from "../models/quote";
import { Appointment } from "../models/appointment";

export class Job implements Deserializable {
   accountId: number;
   id: number;
   title: string;
   virtualTitle: string;
   description: string;
   createdAt: Date;
   updatedAt: Date;
   contactId: number;
   businessId: number;
   propertyId: number;
   quoteId: number
   status: string;
   isOpen: boolean;
   completedDate: Date;
   Contact: Contact;
   Business: Business;
   Property: Property;
   Invoices: Invoice[];
   Quote: Quote;
   Appointments: Appointment[];
   invoiceTotal: number;
   jobTotal: number;
   jobBalance: number;

   // many invoices (foreign key on invoice)
   // many quotes (foreign key on quote)
   // 1 customer - Job can only be for 1 customer
   // status - Job has a status
   // many users assigned - Job has many users assigned
   // many appointments (foreign key on appointment)
   // 1 property
   // Feature: Display appointments list & status (done or not) and who is assigned to it
   // Feature: Display customer & property
   // Feature: Display overall job status
   // Feature: Display quotes and quote status
   // Feature: Display invoices and status
   // Feature: Display who is assigned to the job
   // Feature: Display list of notes and who added them
   // Feature: Link to job from Appointment view screen
   // Feature: Link to job from Invoice view screen
   // Feature: Link to job from Quote view screen
   // Feature: Link to job from Customer view screen
   // Feature: List jobs with title & status


   constructor() {
    this.status = "NEW";
    this.isOpen = true; // Default value for isOpen, change it as per your logic
   }

   // Virtual Property: Job Total
   // get jobTotal(): number {
   //    if (this.Quote) {
   //       // We have a Quote therefore the job's worth is the Quote's total
   //       return this.Quote?.getTotal?.totalIncTax || 0; // Use the Quote's totalIncTax, or 0 if no Quote
   //    }
   //    else {
   //       // We don't have a Quote, so the job's worth is the sum of all Invoices
   //       return this.invoiceTotal || 0; // Use invoiceTotal from API, or 0 if no Invoices
   //    }
   // }

   // // Virtual Property: Job Balance
   // get jobBalance(): number {
   //    return this.jobTotal - (this.invoiceTotal || 0); // Use invoiceTotal from API
   // }

   deserialize(input: any) {
      Object.assign(this, input);

      // Date objects
      //this.createdAt = new Date(Date.parse(input.startTime));
      //this.updatedAt = new Date(Date.parse(input.endTime));

      // Map Contact to Model
      if (input.Contact)
         this.Contact = new Contact().deserialize(input.Contact);
      
      // Map Property to Model
      if (input.Property)
         this.Property = new Property().deserialize(input.Property);

      // Map Business to Model
      if (input.Business)
         this.Business = new Business().deserialize(input.Business);

      // Map Invoice to Model
      if (input.Invoices && input.Invoices.length > 0) {
         this.Invoices = input.Invoices.map((invoice: any) => new Invoice().deserialize(invoice));
      }
      else {
         this.Invoices = [];
      }

      // Map Quote to Model
      if (input.Quote)
         this.Quote = new Quote().deserialize(input.Quote);

      // Map Appointments to Model
      if (input.Appointments && input.Appointments.length > 0) {
         this.Appointments = input.Appointments.map((appointment: any) => new Appointment().deserialize(appointment));
      }
      else {
         this.Appointments = [];
      }

      // Open
      if (typeof input.isOpen !== 'undefined') {
         this.isOpen = input.isOpen;
      }

      // Created & updated
      this.createdAt = new Date(Date.parse(input.createdAt));
      this.updatedAt = new Date(Date.parse(input.updatedAt));
      
      return this;
   }
}